module Meevo.Plugins.AppointmentBook.Services {
    export class AppointmentBookFilterActionsService {
        static $inject = ['appointmentBookGlobalsService', 'appointmentBookHelperService', '$rootScope',
            'restServer', 'appointmentBookModalService', 'meevo.components.suggestionsService', 'meevo.components.common.IdentityService', "$translate"];

        constructor(private globals, private helper, private rootScope, private restServer, private modal, private suggestionsService: Meevo.Components.ISuggestionsService, private identityService: Meevo.Components.Common.IIdentityService,
            private $translate: angular.translate.ITranslateService) {
            this.showCascadeView = (this.helper.getUserAppointmentBookView() == Meevo.Model.EmployeeAppointmentBookViewEnum.Cascade);
        }

        public filteredServices: Array<any>;
        public filteredEmployees: Array<any>;
        public filteredEmployeeCategories: Array<any>;
        public filteredResources: Array<any>;
        public filteredPriceLevels: Array<any>;
        public displayNoShows: boolean;
        public gender: number;
        private isInitialFilterPending: boolean = false;
        public includeFilterData: boolean = false;
        resourceCountResourceCatFilter: any;
        isPrecisionView: boolean = false;
        isGrouped: boolean = false;
        groupAppointment: any;
        scrollToCurrentDate: boolean = false;

        public builder: IAppointmentBookBuilderService = null;

        // min/max dates to reduce building ~200 years of unnecessary calendar DOM
        public minCalendarDate = moment().add('year', -5).startOf('year').toDate();
        public maxCalendarDate = moment().add('year', 5).endOf('year').toDate();
        public dateString = moment().toDate();
        public dates = [];
        public dateType = Meevo.Model.AppointmentBookDateTypeFilter.Day;

        public cellWidthPercent: number = this.globals.defaultColumnPercent;
        public cellHeightPercent: number = this.globals.defaultRowPercent;

        public pendingAppointmentCount: any = { pendingCount: 0, pendingList: {} };

        public asLocation: any = null;
        columnHeaderOrder: string[];

        public showCascadeView: boolean;

        public resourcesAvailableCount: number = 0;

        public isPendingFilter: boolean = false;

        setBuilderService(builderParam: IAppointmentBookBuilderService) {
            this.builder = builderParam;
        }

        setDefaults() {
            this.dateString = moment().toDate();
            this.dateType = Meevo.Model.AppointmentBookDateTypeFilter.Day;
            this.filteredServices = undefined;
            this.filteredEmployees = undefined;
            this.filteredEmployeeCategories = undefined;
            this.filteredResources = undefined;
            this.filteredPriceLevels = undefined;
            this.displayNoShows = true;
            this.isPrecisionView = false;
            this.setPrecisionBookIconTooltip();
            this.isGrouped = false;
        }

        recalculateDate(newDate: Date = null) {
            if (newDate) {
                this.dateString = newDate;
                this.dates = [];
            }

            if (this.dates && this.dates.length > 0) {
                return;
            }

            this.dates = [];

            let firstDate = moment(this.dateString).toDate();

            if (this.dateType === Meevo.Model.AppointmentBookDateTypeFilter.Day) {
                this.dates.push(firstDate);
            } else {
                const weekDay = moment(firstDate);
                const startDayOfWeek = this.getStartDayOfWeek();
                weekDay.day(startDayOfWeek);

                if (weekDay > moment(this.dateString)) {
                    weekDay.add(-7, "d");
                }

                for (let day = 0; day < 7; day++) {
                    this.dates.push(weekDay.clone());
                    weekDay.add(1, "d");
                }
            }
        }

        getStartDayOfWeek(): number {
            if (!this.globals.businessInfo) {
                return 0;
            }

            let startDayOfWeek;

            switch (parseInt(this.globals.businessInfo.startAppointmentBookDayOn)) {
                case Meevo.Model.WeekdayNameEnum.Sunday:
                    startDayOfWeek = 0;
                    break;
                case Meevo.Model.WeekdayNameEnum.Monday:
                    startDayOfWeek = 1;
                    break;
                case Meevo.Model.WeekdayNameEnum.Tuesday:
                    startDayOfWeek = 2;
                    break;
                case Meevo.Model.WeekdayNameEnum.Wednesday:
                    startDayOfWeek = 3;
                    break;
                case Meevo.Model.WeekdayNameEnum.Thursday:
                    startDayOfWeek = 4;
                    break;
                case Meevo.Model.WeekdayNameEnum.Friday:
                    startDayOfWeek = 5;
                    break;
                case Meevo.Model.WeekdayNameEnum.Saturday:
                    startDayOfWeek = 6;
                    break;
            }

            return startDayOfWeek;
        }

        applyParams(params, isInitialLoad = false) {
            this.restServer.asLocationId = null;
            this.asLocation = null;

            if (_.isEmpty(params)) {
                return;
            }

            this.suggestionsService.getSuggestions(params.scanRequest);

            if (params.employeeAction == 'self') {
                // handled in convo.service resolveConvoInput()
            }

            if (!_.isNull(params.employees) && !_.isUndefined(params.employees)) {
                this.filteredEmployees = params.employees;
                // if employees were specified, make sure the view is switched to employees
                if (!_.isEmpty(params.employees)) {
                    this.globals.isEmployeeView = true;
                }
            }
            else {
                // clear all filters if employees are not found in the params
                this.clearFilters();
            }

            if (!_.isNull(params.priceLevels) && !_.isUndefined(params.priceLevels)) {
                this.filteredPriceLevels = params.priceLevels;
            }

            if (!_.isEmpty(params.dates)) {
                this.dates = _(params.dates).unique(true, (item: Date) => item.valueOf());
                this.dateString = this.dates[0];
                this.dates.length === 1 ? this.selectDay(false) : this.selectWeek(false);
            } else {
                this.dates = [];
            }

            if (!_.isEmpty(params.time)) {
                this.builder.scrollToTime(params.time);
            }

            // For launching appt book from call center impersonating location.
            if (params.asLocation && params.asLocation.id > 0) {
                this.restServer.asLocationId = params.asLocation.id;
                this.asLocation = params.asLocation;
            }

            if ((params.scanRequest != null && params.scanRequest.scanServices != null && params.scanRequest.scanServices[0] != null && params.scanRequest.scanServices[0].genderPreferenceEnum == 109) || params.gender != null && params.gender == 109) {
                this.gender = Meevo.Model.GenderEnum.Female;
            }
            else if ((params.scanRequest != null && params.scanRequest.scanServices != null && params.scanRequest.scanServices[0] != null && params.scanRequest.scanServices[0].genderPreferenceEnum == 108) || params.gender != null && params.gender == 108) {
                this.gender = Meevo.Model.GenderEnum.Male;
            }

            this.columnHeaderOrder = params.columnHeaderOrder;
            this.scrollToCurrentDate = params.scrollToCurrentDate;

            if (isInitialLoad) {
                this.recalculateDate();
            }
            else {
                this.filterBook();
            }
        }

        changeAppointmentBookDateAndTime(serviceOpening, isInitialLoad = false) {

            if (serviceOpening.date) {
                this.recalculateDate(moment(serviceOpening.date).toDate());
            } else {
                this.dates = [];
            }

            if (serviceOpening.startTime) {
                this.builder.scrollToTime(moment(serviceOpening.startTime).format('HH:mm'));
            }

            this.filterBook();
        }

        dateChanged() {
            if (this.globals.appointmentBookLoaded) {
                this.dates = [];
                this.filterBook();
            }
        }

        selectDay(refresh: boolean, force?: boolean) {
            if (this.globals.disableDateChange && !force) {
                return;
            }
            this.dateType = Meevo.Model.AppointmentBookDateTypeFilter.Day;
            this.globals.isDayView = true;
            if (refresh) {
                this.filterBook();
            }
        }

        selectWeek(refresh: boolean = false, force?: boolean) {
            if (this.globals.disableDateChange && !force) {
                return;
            }
            this.dateType = Meevo.Model.AppointmentBookDateTypeFilter.Week;
            this.globals.isDayView = false;
            if (refresh) {
                this.filterBook();
            }
        }

        today() {
            if (this.globals.disableDateChange) {
                return;
            }
            this.selectDay(false);
            this.globals.isDayView = true;
            this.recalculateDate(this.helper.getBusinessDate());
            this.filterBook();
        }

        refresh() {
            if (this.globals.disableDateChange) {
                return;
            }
            this.filterBook(false);
        }

        weekJump(weeksToJump: number) {
            this.globals.isDayView ? this.selectDay(false) : this.selectWeek();
            this.recalculateDate(moment(this.dateString).add(weeksToJump, 'weeks').toDate());
            this.filterBook();

            $('#appointmentBookGo').hide();
        }

        zoomIncrementsHorizontal = [
            20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150
        ];

        zoomIncrementsVertical = [
            40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100, 105, 110, 115, 120, 125, 130, 135, 140, 145, 150
        ];

        calculateHorizontalZoom() {
            this.globals.columnWidthPercent = this.cellWidthPercent;
            this.globals.columnWidth = (this.globals.columnWidthPercent / 100.0) * this.globals.constColumnWidth;
        }

        calculateVerticalZoom() {
            this.globals.cellHeightPercent = this.cellHeightPercent;
            this.globals.cellHeight = (this.globals.cellHeightPercent / 100.0) * this.globals.constCellHeight;
        }

        initZoomLevel() {
            this.calculateHorizontalZoom();
            this.calculateVerticalZoom();
        }

        updateHorizontalZoom() {
            this.calculateHorizontalZoom();
            this.filterBook(false);
        }

        updateVerticalZoom() {
            this.calculateVerticalZoom();
            this.filterBook(false);
        }

        nextDate() {
            if (this.globals.disableDateChange) {
                return;
            }
            let numDays = this.dateType == Meevo.Model.AppointmentBookDateTypeFilter.Day ? 1 : 7;
            this.recalculateDate(moment(this.dateString).add(numDays, "days").toDate());
            this.filterBook();
        }

        previousDate() {
            if (this.globals.disableDateChange) {
                return;
            }
            let numDays = this.dateType == Meevo.Model.AppointmentBookDateTypeFilter.Day ? -1 : -7;
            this.recalculateDate(moment(this.dateString).add(numDays, "days").toDate());
            this.filterBook();
        }

        updateFilters(employeeCategories: Array<any>, employees: Array<any>, services: Array<any>, resources: Array<any>, gender?: number) {
            this.filteredEmployeeCategories = employeeCategories;
            this.filteredEmployees = employees;
            this.filteredServices = services;
            this.filteredResources = resources;
            this.gender = gender;
        }

        clearFilters() {
            this.updateFilters([], [], [], [], null); //Set all filters to empty
        }

        showFilters() {
            if (this.isGrouped) {
                this.unGroup();
                return;
            }
            this.modal.showFilters(this.filteredServices, this.filteredEmployees, this.filteredEmployeeCategories, this.filteredResources, this.gender);
        }

        showAppointmentBookFilterMenu()
        {
            if (this.isGrouped) {
                this.unGroup();
                return;
            }
            this.modal.showAppointmentBookFilterMenu(this.globals.opacityFilterSelections);

        }

        showResourceCountFilters() {
            this.modal.showResourceCountFilters(this.resourceCountResourceCatFilter);
        }

        updateResourceCountFilters(resourceCat) {
            this.resourceCountResourceCatFilter = resourceCat;
            this.helper.loadCounts(true, false, this.dates, Meevo.Model.Guard.isSomething(resourceCat) ? resourceCat.id : null);
        }

        showAllEmployeesToday() {
            this.columnHeaderOrder = undefined;
            this.clearFilters();
            this.today();
        }

        private captureScrollTime() {
            if (!this.globals.scrollContainer) {
                return;
            }

            let rows = $("#divRows").children();
            let scrollY = this.globals.scrollContainer.scrollTop();

            for (var i = 0; i < rows.length; i++) {
                let row = $(rows[i]);
                let top = row.position().top;

                if (top <= scrollY && top + row.height() > scrollY) {
                    this.globals.scrollTime = row.attr("id");
                    this.globals.extraScrollTime = scrollY - top;
                    break;
                }
            }
        }

        private captureScrollColumn() {
            if (!this.globals.scrollContainer) {
                return;
            }

            this.globals.bookLastScrollXPosition = this.globals.scrollContainer.scrollLeft();
        }

        beforeViewChanged(view) {
            //Toggle function which triggers filter book function
            if (this.globals.disableDateChange) {
                return;
            }

            let unGroup: boolean = true;
            switch (view) {
                case "empResView":
                    this.globals.isEmployeeView = !this.globals.isEmployeeView;
                    unGroup = this.shouldUnGroup();
                    if (!unGroup) {
                        this.buildGroupEmployeeResourceFilters(this.groupAppointment);
                    }

                    if (this.globals.cutCopyIds.length > 0) {
                        this.helper.updateStepsOnChangeFilter(this.globals.cutCopyIds);
                    }
                    break;
                case "dayWeekView":
                    this.globals.isDayView = !this.globals.isDayView;
                    this.globals.isDayView ? this.selectDay(false) : this.selectWeek(false);
                    this.dates = [];
                    break;
            }

            if (this.globals.isEmployeeView && this.globals.opacityFilterSelections && this.globals.opacityFilterSelections.isUnassignedEmployee) {
                this.globals.opacityFilterSelections.isUnassignedEmployee = false;
            }

            this.filterBook(unGroup);
        }

        viewChanged() {
            this.filterBook();
        }

        getPendingServices() {
            var that = this;
            this.restServer.LoadPendingAppointmentRequest().then(result => {
                that.pendingAppointmentCount = result.data;
                if (!that.globals.canViewAll) {
                    that.pendingAppointmentCount.pendingList = _.filter(that.pendingAppointmentCount.pendingList,
                        (pendingItem: any) => { return pendingItem.employeeId == that.identityService.loggedInUserId() });
                }
            });
        }
        showPendingServices() {
            this.helper.clearBook();
            this.unGroup(false);
            if ($("#pendingCount").hasClass("active")) {
                $("#pendingCount").removeClass("active");
                this.isPendingFilter = false;
                this.filterBook();
            } else {
                $("#pendingCount").addClass("active");
                this.isPendingFilter = true;
                this.builder.loadPendings(this.pendingAppointmentCount.pendingList);
            }
        }

        showCascadeOrDefaultView(showInCascadeMode) {
            if (this.globals.isEmployeeView) {
                this.showCascadeView = showInCascadeMode;
                this.filterBook(false);
            }
        }

        filterBook(unGroup: boolean = true, overrideTimeShift?: boolean)
        {
            if (!$("#divAppointmentBookRootContainer").length) {
                this.rootScope.$broadcast("FILTER BOOK");
            }

            if (unGroup) {
                this.unGroup(false);
            }

            this.globals.showLeaves = false;
            this.captureScrollTime();
            this.captureScrollColumn();
            this.globals.disableDateChange = true;

            this.recalculateDate();

            let employeeIds = [];
            let serviceIds = [];
            let resourceIds = [];
            let employeeCategoryIds = [];

            if (isObject(this.filteredEmployeeCategories)) {
                for (var i = 0; i < this.filteredEmployeeCategories.length; i++) {
                    if (this.filteredEmployeeCategories[i] != undefined && this.filteredEmployeeCategories[i].id != undefined) {
                        employeeCategoryIds.push(this.filteredEmployeeCategories[i].id);
                    }
                }
            }

            if (isObject(this.filteredEmployees)) {
                for (var i = 0; i < this.filteredEmployees.length; i++) {
                    if (this.filteredEmployees[i] != undefined && this.filteredEmployees[i].id != undefined) {
                        employeeIds.push(this.filteredEmployees[i].id);
                    }
                }
            }

            if (isObject(this.filteredServices)) {
                for (var i = 0; i < this.filteredServices.length; i++) {
                    if (this.filteredServices[i] != undefined && this.filteredServices[i].id != undefined) {
                        serviceIds.push(this.filteredServices[i].id);
                    }
                }
            }

            if (isObject(this.filteredResources)) {
                for (var i = 0; i < this.filteredResources.length; i++) {
                    if (this.filteredResources[i] != undefined && this.filteredResources[i].id != undefined) {
                        resourceIds.push(this.filteredResources[i].id);
                    }
                }
            }

            if (this.globals.phoneMode) {
                employeeIds = this.globals.defaultEmployeeIds;
            }

            this.builder.loadStructure(
                this.dates,
                employeeCategoryIds,
                this.helper.getFinalEmployeeFilters(employeeIds),
                serviceIds,
                resourceIds,
                this.displayNoShows,
                this.filteredPriceLevels,
                this.showCascadeView,
                overrideTimeShift,
                this.columnHeaderOrder,
                this.gender,
                this.isPrecisionView);
        }

        getResourceAvailableCount() {
            return this.resourcesAvailableCount;
        }
        precisionViewTooltip;
        togglePrecisionView() {
            if (!this.globals.displayPrecisionTimingToggle || this.globals.disableDateChange) {
                return;
            }
            this.isPrecisionView = !this.isPrecisionView;
            if (this.isPrecisionView) {
                this.rootScope.appointmentBookIncrement = 5;
            }
            else {
                this.rootScope.appointmentBookIncrement = this.helper.convertAppointmentBookIncrementToNumber(this.globals.businessInfo.appointmentBookIncrement);
            }
            this.modal.disposeCutCopyClipboard();
            this.setPrecisionBookIconTooltip();
            this.refresh();
        }

        setPrecisionBookIconTooltip() {
            if (this.isPrecisionView) {
                this.precisionViewTooltip = this.$translate.instant("LABEL_PRECISION_TIMING_BACK_TOOLTIP", { interval: this.helper.convertAppointmentBookIncrementToNumber(this.globals.businessInfo.appointmentBookIncrement) });
            }
            else {
                this.precisionViewTooltip = this.$translate.instant("LABEL_PRECISION_TIMING_TOOLTIP");
            }
        }

        group(appointmentId)
        {
            if (this.globals.disableDateChange) {
                return;
            }
            this.isGrouped = true;
            this.selectDay(false);
            $("#pendingCount").removeClass("active");

            this.globals.opacityFilterSelections = $.extend(true, {}, this.globals.opacityFilterSelectionsDefaults);
            this.globals.opacityFilterSelections.appointmentId = appointmentId;
            this.restServer.getAppointment(appointmentId, false, true).then((result) => {
                this.groupAppointment = result.data;
                if (!this.displayNoShows) {
                    this.groupAppointment.services = this.groupAppointment.services.filter(service => service.transitionState !== Model.AppointStateEnum.NoShow);
                }
                if (this.shouldUnGroup()) {
                    this.unGroup(true);
                    return;
                }
                this.buildGroupEmployeeResourceFilters(this.groupAppointment);
                this.recalculateDate(result.data.appointmentDate);
                this.filterBook(false, true);
            }
            );
        }

        buildGroupEmployeeResourceFilters(appointment)
        {
            let employees: any[] = [];
            let resources: any[] = [];
            let ids: any[] = [];
            appointment.services.forEach(service => {
                let id = this.globals.isEmployeeView ? service.employeeId : service.resourceId;
                if (id && ids.indexOf(id) === -1) {
                    if (this.globals.isEmployeeView) {
                        employees.push({
                            id: service.employeeId,
                            displayName: service.employeeDisplayName
                        });
                    } else {
                        resources.push({
                            id: service.resourceId,
                            displayName: service.resourceDisplayName
                        });
                    }
                    ids.push(id);
                }
            });
            this.updateFilters([], employees, [], resources, null);
        }

        reGroup()
        {
            this.group(this.globals.opacityFilterSelections.appointmentId);
        }

        unGroup(refresh: boolean = true)
        {
            if (this.isGrouped && !this.globals.disableDateChange) {
                this.isGrouped = false;
                this.globals.opacityFilterSelections.appointmentId = undefined;
                this.clearFilters();
                if (refresh) {
                    this.filterBook(true, true);
                }
            }
        }

        shouldUnGroup() {
            let unGroup = true;
            if (this.isGrouped && this.groupAppointment) {
                unGroup = this.dates.indexOf(moment(this.groupAppointment.appointmentDate).format()) === -1 // Date of appointment probably changed and no longer on date being viewd
                    || ((this.globals.isEmployeeView && _(this.groupAppointment.services).every(service => !service.employeeId)) ||
                        (!this.globals.isEmployeeView && _(this.groupAppointment.services).every(service => !service.resourceId)));
            }
            return unGroup;
        }
    }

    //DON"T use this... angular.module('ApptBookApp').service('appointmentBookFilterActionsService', AppointmentBookFilterActionsService);
    angular.module('ApptBookApp').service('Meevo.Plugins.AppointmentBook.Services.AppointmentBookFilterActionsService', AppointmentBookFilterActionsService);
}